import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  saveDmRecordStatus: null,
  filterGroupData: {},
  filterData: {},
  DmRecordData: {},
};

const slice = createSlice({
  name: 'dmRecords',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    filterGroupDropDownData: (state, action) => {
      state.filterGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    filterDropDownData: (state, action) => {
      state.filterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    saveDmRecords: (state, action) => {
      state.saveDmRecordStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    getDmRecordData: (state, action) => {
      state.DmRecordData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.isSystemNoteLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
      state.isSystemNoteLoading = false;
    },
    resetStatus: (state, action) => {
      state.saveDmRecordStatus = null;
      state.DmRecordData = null;
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
    },
    resetNoteMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
    },
    resetData: (state, action) => {
      state.DmRecordData = {};
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  filterGroupDropDownData,
  filterDropDownData,
  fetchSuccess,
  fetchError,
  resetMessage,
  postSystemNotesData,
  resetStatus,
  resetData,
  fetchAddSuccess,
  saveDmRecords,
  resetRecordStatus,
  fetchNoteStart,
  deleteDmRecordData,
  filter,
  getDmRecordData,
  resetNoteMessage,
} = slice.actions;

export const fetchFilterGroupDropdownData = (recordType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfiltergroup/find/all/filtergroupcodeanddescription`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(filterGroupDropDownData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchCodeDropdownData = (recordType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfilter/findall/filtercode`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(filterDropDownData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postDmRecords = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('dmrecord/save/record', details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(saveDmRecords(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`dmrecord/save/dmrecordnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchDmRecord = (recordId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmrecord/get/record/${recordId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getDmRecordData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const Resetdata = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetNoteMessage());
  };
};

export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetNoteMessage());
  };
};
